import axios from "axios";
import { authEndpoint } from "../../../routes/api_endpoints";

/**Logs out */
const logoutPromise = () =>
  new Promise((resolve, reject) => {
    axios
      .post(`${authEndpoint}/logout`, {}, { withCredentials: true })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });

export default logoutPromise;
